import {httpClientService} from '../settingsApi/httpClientService';

import {commonCheckoutClientWrapper} from './commonCheckoutClientWrapper';
import {getCheckoutSessionStatusFromCommonCheckoutApi} from './getCheckoutSessionStatusFromCommonCheckoutApi';

export async function createCheckoutSessionFromCommonCheckoutApi({
  merchantId,
  merchantTransactionId,
  amount,
  hsid,
  phoneNumber,
  statementDescriptorSuffix = '',
  metadata = {},
}: {
  merchantId: string;
  merchantTransactionId: string;
  amount: number;
  hsid?: string;
  phoneNumber?: string;
  statementDescriptorSuffix?: string;
  metadata?: {[key: string]: string};
}) {
  const httpClient = httpClientService.getHttpClient({api: 'WALLET'});
  /* POST /v1/sessions
    {
      "customer": {
        "name": "To test PM methods",
        "email": "test@test.com",
        "ssnLastFour": "0001",
        "dateOfBirth": "1958-04-27",
        "phoneNumber": {
          "countryCode": "1",
          "number": "7327818322"
        },
        "hsid": "4608d596-d459-4b6b-8e9a-38f93e07de99",
        "metadata": {
          "email": "ramki@test.com"
        }
      },
      "payment": {
        "statementDescriptorSuffix": "",
        "merchantTransactionId": "unique-merchant-transaction-id-578",
        "amount": 4200,
        "authorizeCard": true,
        "metadata": {
          "orderId": "t6789p09",
          "orderType": "Medcine"
        }
      },
      "cashier": "Auditor"
    }
  */
  const request = {
    url: '/v1/sessions',
    method: 'POST' as Methods,
    data: {
      customer: {
        phoneNumber: {
          countryCode: '1',
          number: phoneNumber
        },
        hsid: hsid||null
      },
      payment: amount > 0 ? {
        statementDescriptorSuffix,
        merchantTransactionId,
        amount,
        authorizeCard: false,
        metadata
      } : null,
      cashier: ''
    },
  };
  const response = await commonCheckoutClientWrapper<CheckoutSessionsResponse>({httpClient, request});
  const {
    statusUrl = '',
    data: {hcpToken = '', checkoutSession: {id: checkoutSessionId = ''} = {}} = {},
    headers,
  } = response;

  const publicKey = headers?.['x-vendor-stripe-public-key'] || '';

  const checkStatus = async () => getCheckoutSessionStatusFromCommonCheckoutApi({updateStatusUrl: statusUrl});

  return {statusUrl, hcpToken, checkoutSessionId, merchantTransactionId, checkStatus, publicKey, response};
}
